import { render, staticRenderFns } from "./affiliate-work-request-form.vue?vue&type=template&id=54a0fc6c&scoped=true&"
import script from "./affiliate-work-request-form.vue?vue&type=script&lang=js&"
export * from "./affiliate-work-request-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a0fc6c",
  null
  
)

export default component.exports